import { FC } from 'react';
import { DateInput } from '@mantine/dates';
import moment from 'moment';
import { Label } from 'components/CreateOrderForm';
import { ReactComponent as IconCalendar } from 'components/CreateAlertsModal/img/iconCalendar.svg';
import { dateInputStyles } from '../constants';
import styles from '../ModalAddingDocument.module.scss';

interface DateFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const DateField: FC<DateFieldProps> = ({ label, value, onChange, error = '' }) => (
  <div className={styles.dateField}>
    <Label text={label} />
    <DateInput
      value={value ? new Date(value) : null}
      onChange={(date) => {
        if (date) {
          onChange(moment(date).format('YYYY-MM-DD'));
        } else {
          onChange('');
        }
      }}
      placeholder='Не выбрана'
      rightSection={<IconCalendar style={{ cursor: 'pointer' }} />}
      styles={{
        ...dateInputStyles,
        input: {
          ...dateInputStyles.input,
          border: error ? '1px solid red' : 'none',
        },
      }}
      highlightToday
      locale='ru'
      valueFormat='DD.MM.YYYY'
      clearable
      allowDeselect
      dateParser={(input) =>
        moment(input, ['DD.MM.YYYY', 'D MMMM YYYY', 'YYYY-MM-DD']).toDate()
      }
      popoverProps={{
        zIndex: 100001,
        middlewares: { flip: false, shift: false },
      }}
    />
    {error && <div className={styles.error}>{error}</div>}
  </div>
);
